export const SET_ACTIVE_QUESTION_SUBSCRIPTION =
  "SET_ACTIVE_QUESTION_SUBSCRIPTION";
export const SET_ACTIVE_QUESTION = "SET_ACTIVE_QUESTION";
export const CLEAR_ACTIVE_QUESTION = "CLEAR_ACTIVE_QUESTION";
export const VALIDATE_QUESTION_REQUIRED = "VALIDATE_QUESTION_REQUIRED";
